var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightHs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "11px",
    viewBox: "0 0 6 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrowRightHS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.6035242,18 C14.4977974,18 14.4052863,17.959707 14.3259912,17.8791209 L9,12.4798535 L14.2863436,7.12087912 C14.4449339,6.95970696 14.6960352,6.95970696 14.8414097,7.12087912 C15,7.28205128 15,7.53724054 14.8414097,7.68498168 L10.123348,12.4798535 L14.8810573,17.3150183 C15.0396476,17.4761905 15.0396476,17.7313797 14.8810573,17.8791209 C14.8017621,17.959707 14.7092511,18 14.6035242,18 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4--Prospects-Empty-state",
    transform: "translate(-1528.000000, -746.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hot-RHP-Members-v2",
    transform: "translate(1266.000000, 725.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(227.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(38.000000, 12.000000) scale(-1, 1) translate(-38.000000, -12.000000) translate(26.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "arrowRightHS",
    fill: "#010101",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightHs);
export default __webpack_public_path__ + "static/media/arrowRightHS.31f9043acc6e1bc778d450d282793bed.svg";
export { ForwardRef as ReactComponent };